import * as types from "../_constants";
const initialState = {
  loading: false,
  machines: "",
  error: null,
};
export const machineReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_MACHINE_REQUEST:
      return {
        ...state,
        loading: true,
        machines: "",
      };
    case types.GET_MACHINE_SUCCESS:
      return {
        ...state,
        loading: false,
        machines: action.payload,
        error: "",
      };
      break;
    case types.SET_MACHINE_ID:
      return { ...state, machineId: action.payload };
      break;
    case types.GET_MACHINE_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
        machines: "",
      };
      break;
    default:
      return state;
  }
};
